import type { DateParameter, SelectOption } from "./types";

/** Human labels for every `DateParameter` enum member. Shared by the
 * Custom period "Use parameter" dropdown and the Dynamic fields picker. */
export const DATE_PARAMETER_LABELS: Readonly<Record<DateParameter, string>> = {
  PERIOD_BEGIN: "Period begin",
  PERIOD_END: "Period end",
  DUE_DATE: "Due date",
  ISSUE_DATE: "Issue date",
  YEAR_BEGIN: "Year begin",
  QUARTER_BEGIN: "Quarter begin",
  MONTH_BEGIN: "Month begin",
  PRIOR_PERIOD_BEGIN: "Prior period begin",
  PRIOR_PERIOD_END: "Prior period end",
  NOTICE_DATE: "Notice date",
  DATE_1: "Date 1",
  DATE_2: "Date 2",
  DATE_3: "Date 3",
  DISTRIBUTION_DATE: "Distribution date",
  CAPITAL_CALL_DATE: "Capital call date",
  REPORT_DATE: "Report date",
};

const toOption = (value: DateParameter): SelectOption<DateParameter> => ({
  value,
  label: DATE_PARAMETER_LABELS[value],
});

/** Parameter catalogue for CUSTOM + `Use parameter` mode. Omits
 * `REPORT_DATE` — that token is only selectable as a Dynamic date field. */
export const PARAMETER_OPTION_VALUES: ReadonlyArray<DateParameter> = [
  "PERIOD_BEGIN",
  "PERIOD_END",
  "DUE_DATE",
  "ISSUE_DATE",
  "YEAR_BEGIN",
  "QUARTER_BEGIN",
  "MONTH_BEGIN",
  "PRIOR_PERIOD_BEGIN",
  "PRIOR_PERIOD_END",
  "NOTICE_DATE",
  "DATE_1",
  "DATE_2",
  "DATE_3",
  "DISTRIBUTION_DATE",
  "CAPITAL_CALL_DATE",
];

export const PARAMETER_OPTIONS: ReadonlyArray<SelectOption<DateParameter>> =
  PARAMETER_OPTION_VALUES.map(toOption);

/** Dynamic fields picker catalogue: Report date, then the CUSTOM parameter list. */
export const DYNAMIC_DATE_PICKER_VALUES: ReadonlyArray<DateParameter> = [
  "REPORT_DATE",
  ...PARAMETER_OPTION_VALUES,
];

export const DYNAMIC_DATE_PICKER_OPTIONS: ReadonlyArray<SelectOption<DateParameter>> =
  DYNAMIC_DATE_PICKER_VALUES.map(toOption);

export const getDateParameterLabel = (parameter: DateParameter): string =>
  DATE_PARAMETER_LABELS[parameter];
